export default __webpack_public_path__ + "static/media/stuart-marshall-2019-contributions.1a7dc230.png";